import Fetch from '@/utils/Fetch';

const getMessages = async (itemID: any, pageIndex: any, pageSize: any) => {
  return await Fetch.post({
    url: '/Message/GetMessages',
    params: {
      itemID,
      pageIndex,
      pageSize,
      DisplayMessage: false
    },
  } as any);
};

const getMessage = async (id: any) => {
  return await Fetch.get({
    url: `/Message/${id}`
  } as any);
};

export default {
  getMessages,
  getMessage
};
